import { render } from "./industries.vue?vue&type=template&id=9f351ab2"
import script from "./industries.vue?vue&type=script&lang=js"
export * from "./industries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__